import { render } from "./tags-fill.vue?vue&type=template&id=52756386"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/tags-fill.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52756386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52756386', __exports__)) {
    api.reload('52756386', __exports__)
  }
  
  module.hot.accept("./tags-fill.vue?vue&type=template&id=52756386", () => {
    api.rerender('52756386', render)
  })

}


export default __exports__